import React from 'react';
import './index.css';

interface P {
    onClick?: any
    label?: string
}

export default ({onClick, label}: P) => {
    return(
        <div {...{onClick}} className={`scroll-down-btn ${label ? 'with-label' : ''}`}>
            {label && <span className={`scroll-down-label non-selectable`}>{label}</span>}
            <div className={`scroll-down-chevron`}>
                <div className={`basic-arrow upper-arrow`}>
                    <div className={`ba-before`}/>
                    <div className={`ba-after`}/>
                </div>
                <div className={`basic-arrow lower-arrow`}>
                    <div className={`ba-before`}/>
                    <div className={`ba-after`}/>
                </div>
            </div>
        </div>
    )
}
